"use client";

import { c as _c } from "react/compiler-runtime";
import { faDoorClosed, faDoorOpen, faRepeat, faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AnimatePresence, motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import HeaderUserProxyDropdownItem from "./HeaderUserProxyDropdownItem";
export default function HeaderUserProxyDropdown(t0) {
  const $ = _c(28);
  const {
    isOpen,
    profile,
    onClose
  } = t0;
  const {
    address,
    isConnected,
    seizeConnect,
    seizeDisconnect,
    seizeDisconnectAndLogout
  } = useSeizeConnectContext();
  const {
    activeProfileProxy,
    setActiveProfileProxy,
    receivedProfileProxies
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== onClose || $[1] !== setActiveProfileProxy) {
    t1 = async profileProxy => {
      await setActiveProfileProxy(profileProxy);
      onClose();
    };
    $[0] = onClose;
    $[1] = setActiveProfileProxy;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onActivateProfileProxy = t1;
  let t2;
  if ($[3] !== address || $[4] !== profile.handle || $[5] !== profile.wallets) {
    t2 = () => {
      if (profile.handle) {
        return profile.handle;
      }
      const wallet = profile?.wallets?.find(w => w.wallet.toLowerCase() === address?.toLocaleLowerCase());
      if (wallet?.display) {
        return wallet.display;
      }
      if (address) {
        return address.slice(0, 6);
      }
      throw new Error("No label found");
    };
    $[3] = address;
    $[4] = profile.handle;
    $[5] = profile.wallets;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const getLabel = t2;
  let t3;
  if ($[7] !== getLabel) {
    t3 = getLabel();
    $[7] = getLabel;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const [label, setLabel] = useState(t3);
  let t4;
  if ($[9] !== getLabel) {
    t4 = () => setLabel(getLabel());
    $[9] = getLabel;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== address || $[12] !== profile) {
    t5 = [profile, address];
    $[11] = address;
    $[12] = profile;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t4, t5);
  let t6;
  if ($[14] !== activeProfileProxy || $[15] !== isConnected || $[16] !== isOpen || $[17] !== label || $[18] !== onActivateProfileProxy || $[19] !== onClose || $[20] !== profile.pfp || $[21] !== receivedProfileProxies || $[22] !== seizeConnect || $[23] !== seizeDisconnect || $[24] !== seizeDisconnectAndLogout) {
    t6 = isOpen && <motion.div className="tw-fixed tw-left-6 tw-z-[9999] tw-bottom-16 tw-mb-2 tw-mt-1 tw-w-72 tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.2
    }}><div className="tw-mt-1 tw-overflow-hidden tw-w-full tw-rounded-md tw-bg-iron-800 tw-shadow-2xl"><div className="tw-py-2 tw-flow-root tw-overflow-x-hidden tw-overflow-y-auto"><div role="list" className="tw-flex tw-flex-col tw-gap-y-2 tw-divide-y tw-divide-solid tw-divide-iron-700 tw-divide-x-0"><div className="tw-flex tw-flex-col tw-px-2 tw-gap-y-2 tw-mx-0"><div className="tw-h-full"><button type="button" className={`${activeProfileProxy ? "tw-bg-transparent hover:tw-bg-iron-700" : "tw-bg-iron-700"} tw-group tw-py-2.5 tw-w-full tw-h-full tw-border-none tw-text-left tw-flex tw-items-center tw-gap-x-3 tw-text-white tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-3 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out`} onClick={() => onActivateProfileProxy(null)}>{profile.pfp ? <img src={profile.pfp} alt="Profile Picture" className="tw-flex-shrink-0 tw-object-cover tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out" /> : <div className={`${!activeProfileProxy ? "tw-bg-iron-600" : "tw-bg-iron-700 group-hover:tw-bg-iron-600"} tw-flex-shrink-0 tw-h-6 tw-w-6 tw-flex-none tw-rounded-lg tw-transition tw-duration-300 tw-ease-out`} />}<div className="tw-w-full tw-truncate tw-inline-flex tw-items-center tw-justify-between"><span className="tw-text-md tw-font-medium tw-text-white">{label}</span>{!activeProfileProxy && <svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>}</div></button></div>{receivedProfileProxies.map(profileProxy_0 => <HeaderUserProxyDropdownItem key={profileProxy_0.id} profileProxy={profileProxy_0} activeProfileProxy={activeProfileProxy} onActivateProfileProxy={onActivateProfileProxy} />)}</div><div className="tw-h-full tw-px-2 tw-pt-2">{isConnected ? <button onClick={() => {
                seizeDisconnect();
                onClose();
              }} type="button" aria-label="Disconnect" title="Disconnect" className="tw-bg-transparent hover:tw-bg-iron-700 tw-py-2.5 tw-w-full tw-h-full tw-border-none tw-text-md tw-font-medium tw-text-left tw-flex tw-items-center tw-gap-x-3 tw-text-iron-300 hover:tw-text-iron-50 tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-3 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"><FontAwesomeIcon icon={faDoorClosed} height={16} width={16} /><span>Disconnect Wallet</span></button> : <button onClick={() => {
                seizeConnect();
                onClose();
              }} type="button" aria-label="Connect" title="Connect" className="tw-bg-transparent hover:tw-bg-iron-700 tw-py-2.5 tw-w-full tw-h-full tw-border-none tw-text-md tw-font-medium tw-text-left tw-flex tw-items-center tw-gap-x-3 tw-text-iron-300 hover:tw-text-iron-50 tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-3 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"><FontAwesomeIcon icon={faDoorOpen} height={16} width={16} /><span>Connect Wallet</span></button>}</div><div className="tw-h-full tw-px-2 tw-pt-2"><button onClick={() => seizeDisconnectAndLogout(true)} type="button" aria-label="Switch Account" title="Switch Account" className="tw-bg-transparent hover:tw-bg-iron-700 tw-py-2.5 tw-w-full tw-h-full tw-border-none tw-text-md tw-font-medium tw-text-left tw-flex tw-items-center tw-gap-x-3 tw-text-iron-300 hover:tw-text-iron-50 tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-3 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"><FontAwesomeIcon icon={faRepeat} height={16} width={16} /><span>Switch Account</span></button><button onClick={() => seizeDisconnectAndLogout()} type="button" aria-label="Disconnect & Logout" title="Disconnect & Logout" className="tw-bg-transparent hover:tw-bg-iron-700 tw-py-2.5 tw-w-full tw-h-full tw-border-none tw-text-md tw-font-medium tw-text-left tw-flex tw-items-center tw-gap-x-3 tw-text-iron-300 hover:tw-text-iron-50 tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-3 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"><FontAwesomeIcon icon={faRightFromBracket} height={16} width={16} /><span>{isConnected && "Disconnect & "}Logout</span></button></div></div></div></div></motion.div>;
    $[14] = activeProfileProxy;
    $[15] = isConnected;
    $[16] = isOpen;
    $[17] = label;
    $[18] = onActivateProfileProxy;
    $[19] = onClose;
    $[20] = profile.pfp;
    $[21] = receivedProfileProxies;
    $[22] = seizeConnect;
    $[23] = seizeDisconnect;
    $[24] = seizeDisconnectAndLogout;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== t6) {
    t7 = <div><AnimatePresence mode="wait" initial={false}>{t6}</AnimatePresence></div>;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}